<template>
	<div class="component abacus-random">
		<Abacus readOnly="true" />

		<div class="mt-2 d-flex justify-content-center align-items-center">
			<button type="button" class="btn btn-primary" @click.prevent="isPaused ? startAbacus() : stopAbacus()">
				{{ (isPaused ? 'games.resume' : 'games.pause') | translate }}
			</button>
			<router-link to="/games/abacus-random" class="btn btn-secondary ml-3">{{
				'Back' | translate
			}}</router-link>
		</div>
	</div>
</template>

<script>
import Abacus from './Abacus'
import { numberToAbacus } from './helpers'
export default {
	data: () => ({
		isPaused: false,
		currentValue: 0,
		numberIndex: 0,
		intervalId: undefined,
	}),
	name: 'Abacus-random',
	props: ['numbers'],
	components: {
		Abacus,
	},
	// watch: {
	// 	currentValue(value) {
	// 		console.log(value)
	// 	}
	// },
	computed: {
		speed() {
			return (this.$store.state.gameConfig.speed || 1) * 1000
		},
	},
	beforeDestroy() {
		this.stopAbacus()
	},
	methods: {
		stopAbacus() {
			this.isPaused = true
			clearInterval(this.intervalId)
		},
		startAbacus() {
			console.log('is started')
			console.log(this.currentValue)

			this.isPaused = false
			this.intervalId = setInterval(() => {
				if (this.numberIndex >= this.numbers.length) {
					return this.$emit('onGameEnds')
				}

				const number = this.numbers[this.numberIndex]
				this.currentValue = 0 + Math.abs(Number(number))
				this.$store.commit('updateAbacus', numberToAbacus(this.currentValue))
				this.numberIndex += 1
			}, this.speed)
		},
	},
	mounted() {
		this.startAbacus()
	},
}
</script>

<!-- <style lang="scss">
.abacus-random {
	& .abacus {
		width: 400px;
	}
}
</style> -->

<style lang="scss" scoped>
.component {
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
